import { Duplex } from 'readable-stream'
import browser from 'webextension-polyfill'

export class PortDuplexStream extends Duplex {
  private port: browser.Runtime.Port

  constructor(port: browser.Runtime.Port) {
    super({ objectMode: true })
    this.port = port
    this.port.onMessage.addListener((message: unknown) =>
      this.onMessage(message)
    )
    this.port.onDisconnect.addListener(() => {
      this.onDisconnect()
    })
  }

  private onMessage(message: unknown) {
    if (Buffer.isBuffer(message)) {
      const data: Buffer = Buffer.from(message)
      this.push(data)
    } else {
      this.push(message)
    }
  }

  private onDisconnect() {
    this.destroy()
  }

  _read(): undefined {
    return undefined
  }

  _write(
    message: unknown,
    _encoding: BufferEncoding,
    callback: (error?: Error | null) => void
  ): void {
    try {
      if (Buffer.isBuffer(message)) {
        const data: Record<string, unknown> = message.toJSON()
        data._isBuffer = true
        this.port.postMessage(data)
      } else {
        this.port.postMessage(message)
      }
    } catch {
      return callback(new Error('PortDuplexStream - disconnected'))
    }
    return callback()
  }
}
